export default {
  methods: {
    touchAll() {
      Object.keys(this.$v.$params)
        .forEach((param) => {
          this.$v[param].$touch();
        });
    },
    resetAll() {
      Object.keys(this.$v.$params)
        .forEach((param) => {
          this.$v[param].$reset();
          this[param] = '';
        });
    },
  },
};
